"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcCrow = void 0;
const calcCrow = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // km
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const rlat1 = toRad(lat1);
    const rlat2 = toRad(lat2);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(rlat1) * Math.cos(rlat2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c;
    return {
        km: d,
        miles: d * 0.621371,
    };
};
exports.calcCrow = calcCrow;
// Converts numeric degrees to radians
const toRad = (Value) => {
    return (Value * Math.PI) / 180;
};
